import { IconFolderClosed, IconFolderOpen, Text, View } from '@acin/ui-core';
import styled, { css } from 'styled-components';

// This named style is the wrapper for the component i.e. the module.
export const RegTextViewer = styled(View)`
  padding: ${(p) => p.theme.spacing.getSize(2)};
  overflow-y: auto;
  display: flex;
  flex-grow: 1;
  height: calc(100% - ${(p) => p.theme.spacing.getSize(18)});
`;

export const Fragment = styled.div<{ isActive?: boolean }>`
  padding: ${(p) => p.theme.spacing.getSize(4)};
  padding-left: ${(p) => p.theme.spacing.getSize(10)};
  position: relative;
  border-radius: ${(p) => p.theme.spacing.getSize()};
  overflow: hidden;
  width: 100%;

  ${(p) =>
    p.isActive &&
    css`
      background: ${(p) => p.theme.colors.primary.getValue(100).main};

      &:before {
        content: '';
        width: ${(p) => p.theme.spacing.getSize()};
        height: 100%;
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        bottom: 0;
        right: auto;
        background: ${(p) => p.theme.colors.primary.getValue(700).main};
      }
    `};
`;

export const Passage = styled(View)`
  &:not(:first-child) {
    margin-top: ${(p) => p.theme.spacing.getSize(4)};
  }
`;

export const Chapter = styled.h6`
  margin-bottom: ${(p) => p.theme.spacing.getSize()};
`;

export const Open = styled(IconFolderOpen)`
  position: absolute;
  top: 17px;
  left: ${(p) => p.theme.spacing.getSize(4)};
`;

export const Closed = styled(IconFolderClosed)`
  position: absolute;
  top: 17px;
  left: ${(p) => p.theme.spacing.getSize(4)};
`;

export const List = styled(View)`
  overflow-y: auto;
  height: 100%;
  width: 100%;
`;

export const LoadingWrapper = styled(View)`
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const Body = styled(Text)`
  line-height: 1.5;
`;
